export type QualityLevel = "LOW" | "MEDIUM" | "HIGH";

export interface QualitySettings {
  level: QualityLevel;
  pixelRatioCap: number;
  shadows: boolean;
  shadowMapSize: number;
  bloom: boolean;
  particleCount: number;
  fog: boolean;
  antialias: boolean;
}

export const QUALITY_PRESETS: Record<QualityLevel, QualitySettings> = {
  LOW: {
    level: "LOW",
    pixelRatioCap: 1,
    shadows: false,
    shadowMapSize: 512,
    bloom: false,
    particleCount: 60,
    fog: true,
    antialias: false,
  },
  MEDIUM: {
    level: "MEDIUM",
    pixelRatioCap: 1.5,
    shadows: true,
    shadowMapSize: 1024,
    bloom: true,
    particleCount: 160,
    fog: true,
    antialias: true,
  },
  HIGH: {
    level: "HIGH",
    pixelRatioCap: 2,
    shadows: true,
    shadowMapSize: 2048,
    bloom: true,
    particleCount: 320,
    fog: true,
    antialias: true,
  },
};

/** Cheap heuristic auto-detect: hardware concurrency + device pixel ratio + a mobile check. */
export function autoDetectQuality(): QualityLevel {
  const cores = navigator.hardwareConcurrency ?? 4;
  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const memory = (navigator as unknown as { deviceMemory?: number }).deviceMemory ?? 8;

  if (isMobile || cores <= 4 || memory <= 4) return "LOW";
  if (cores <= 8 || memory <= 8) return "MEDIUM";
  return "HIGH";
}
